import type { IconProps } from "types";

const Checkmark = ({ width = "13", height = "9", stroke = "#267847" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8334 1L4.50002 8.33333L1.16669 5"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Checkmark;
